import { Component } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Constants } from '../../../../../shared/constant/constants';
import { Messages } from '../../../../../shared/constant/messages';
import { FileManagerService } from '../../../services/file-manager.service';
import { ToastService } from 'src/app/shared/services';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FocusOnInitDirective } from '@app/shared/directive/modal-focus.directive';
import { TabbingService } from '@app/shared/services/tabbing.service';
import { DynamicTabIndexDirective } from '@app/shared/directive/dynamic-tab-index.directive';

@Component({
  selector: 'app-move-folder',
  templateUrl: './move-folder.component.html',
  styleUrls: ['./move-folder.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, NgIf, TranslateModule, FocusOnInitDirective, DynamicTabIndexDirective],
})
export class MoveFolderComponent {
  isExport = true;
  moveFolderForm: UntypedFormGroup;
  selectAtLeastone = Messages.validationMessage.selectAtLeastone;
  isSubmitted = false;

  constructor(
    private readonly fb: UntypedFormBuilder,
    private readonly modalService: BsModalService,
    private readonly fileManagerService: FileManagerService,
    private readonly flashService: ToastService,
    public tabbingService: TabbingService,
  ) {
    this.moveFolderForm = this.fb.group({
      status: [Constants.FILE_STATUS.NOT_DONE, Validators.required],
    });
  }
  toCancel() {
    this.modalService.hide();
    this.tabbingService.moveElement('fileActionListParent');
  }

  async submitStatus() {
    this.isSubmitted = true;
    if (this.moveFolderForm.valid && this.moveFolderForm.value.status !== Constants.FILE_STATUS.NOT_DONE) {
      // Filing a file away is the last thing a student does with it, and the
      // periodic autosave may not have run since their last edit. Flush first,
      // or that work is never written.
      try {
        const saveTimeout = new Promise((_, reject) => setTimeout(() => reject(new Error('Network timeout. Please check your connection.')), 10000));
        await Promise.race([this.fileManagerService.saveFileData(), saveTimeout]);
      } catch (e) {
        console.error('[MoveFolderComponent] Could not save the file before moving it:', e);
      }
      this.fileManagerService.changeStatusOfFile(this.moveFolderForm.value.status).subscribe(
        () => {
          this.toCancel();
        },
        err => {
          let msg = err.message;
          if (err.status === 0) {
            msg = 'No internet connection Please try in some time.';
            this.toCancel();
          }
          this.flashService.showError(msg);
        },
      );
    } else {
      this.toCancel();
    }
  }

  setMoveFileToggled(value: string) {
    this.moveFolderForm.patchValue({
      status: value,
    });
  }
}
